import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AccessRequestSettingsPageLoader } from '@confluence/access-requests/entry-points/AccessRequestSettingsPageLoader.ts';
import { AdminSecurityPageWrapper } from '@confluence/site-permissions/entry-points/AdminSecurityPageWrapper.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { RestrictedPage } from '@confluence/no-permission/entry-points/RestrictedPage.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

const i18n = defineMessages({
	pageTitle: {
		id: 'access-requests.admin-controls.settings-page.route-title.non-final',
		defaultMessage: 'Access requests',
		description: 'Document title for the Access requests admin page',
	},
});

const AdminAccessRequestsRouteComponent = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { edition } = useSessionData();
	const pageTitle = formatMessage(i18n.pageTitle);

	// Access requests are not available on Free edition, and the nav item is hidden
	// there — block direct navigation to the URL too.
	if (edition === ConfluenceEdition.FREE) {
		return <RestrictedPage />;
	}

	return (
		<AdminSecurityPageWrapper documentTitle={pageTitle}>
			<AccessRequestSettingsPageLoader />
		</AdminSecurityPageWrapper>
	);
};

AdminAccessRequestsRouteComponent.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'productAdminAccessRequestsSettingsScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID as string,
	MainLayout: {
		navView: ADMIN_HOME_ID as string,
	},
});

export const AdminAccessRequestsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: { screenEvent: { name: string } };
		sideNavigationId: string;
		MainLayout: { navView: string };
	};
} = AdminAccessRequestsRouteComponent;
